import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    FaPhone,
    FaMapMarkerAlt,
    FaEnvelope,
    FaFacebook,
    FaWhatsapp,
    FaBars,
    FaTimes
} from 'react-icons/fa';

// Import the logo image
import logo from '../assets/Navbar/marcsri-logonew.jpg';

const Navbar = () => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const navLinks = [
        { path: "/", label: "Home" },
        { path: "/about-us", label: "About Us" },
        { path: "/our-homes", label: "Our Homes" },
        { path: "/our-challenges", label: "Our Challenges" },
        { path: "/how-you-can-help", label: "How You Can Help" },
        { path: "/activities", label: "Activities" },
        { path: "/gallery", label: "Gallery" },
        { path: "/volunteers", label: "Volunteers" },
        { path: "/contact-us", label: "Contact Us" },
    ];

    return (
        <div className="w-100">
            <div className="bg-white text-dark p-3 d-flex flex-column flex-md-row justify-content-between align-items-center">
                {/* Logo - Centered on both mobile & desktop */}
                <div className="order-md-1 d-flex justify-content-center justify-content-md-center w-100 w-md-auto mb-3 mb-md-0">
                    <img
                        src={logo}
                        alt="Marcsri Homes Logo"
                        className="img-fluid"
                        style={{ maxHeight: '150px' }}
                    />
                </div>

                {/* Desktop View - Right Corner Section */}
                <div className="order-md-2 d-none d-md-flex flex-column align-items-end gap-2">
                    <Link
                        to="/contact-us"
                        className="btn btn-primary mb-1"
                        style={{ fontSize: '0.875rem' }}
                    >
                        Donate Now
                    </Link>
                    <p className="mb-0" style={{ fontSize: '0.875rem', whiteSpace: 'nowrap' }}>
                        CALL US NOW: +94 77 7922 009
                    </p>

                    <div className="d-flex align-items-center gap-3 mt-2">
                        <a href="tel:+94777922009" aria-label="Phone" className="text-dark">
                            <FaPhone style={{ color: '#000', cursor: 'pointer' }} size={20} onMouseEnter={(e) => e.target.style.color = '#6b7280'} onMouseLeave={(e) => e.target.style.color = '#000'} />
                        </a>
                        <a href="https://maps.app.goo.gl/p8mQ1ZqWZPSRDMMr5" target="_blank" rel="noopener noreferrer" aria-label="Location" className="text-dark">
                            <FaMapMarkerAlt style={{ color: '#000', cursor: 'pointer' }} size={20} onMouseEnter={(e) => e.target.style.color = '#6b7280'} onMouseLeave={(e) => e.target.style.color = '#000'} />
                        </a>
                        <a href="mailto:marcsrihomes@gmail.com" aria-label="Email" className="text-dark">
                            <FaEnvelope style={{ color: '#000', cursor: 'pointer' }} size={20} onMouseEnter={(e) => e.target.style.color = '#6b7280'} onMouseLeave={(e) => e.target.style.color = '#000'} />
                        </a>
                        <a href="https://web.facebook.com/MarcsriHomes/?_rdc=1&_rdr" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-dark">
                            <FaFacebook style={{ color: '#000', cursor: 'pointer' }} size={20} onMouseEnter={(e) => e.target.style.color = '#6b7280'} onMouseLeave={(e) => e.target.style.color = '#000'} />
                        </a>
                        <a href="https://wa.me/+94771581869" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="text-dark">
                            <FaWhatsapp style={{ color: '#000', cursor: 'pointer' }} size={20} onMouseEnter={(e) => e.target.style.color = '#6b7280'} onMouseLeave={(e) => e.target.style.color = '#000'} />
                        </a>
                    </div>
                </div>

                {/* Mobile Menu Button - Only visible on mobile */}
                <button
                    className="order-md-3 d-md-none btn btn-primary p-2 position-absolute"
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                    style={{
                        right: '1rem',
                        top: '5rem'
                    }}
                >
                    {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                </button>
            </div>

            {/* Desktop Navigation */}
            <nav className="d-none d-md-block navbar navbar-expand-lg navbar-dark bg-primary p-3">
                <div className="container-fluid d-flex justify-content-center align-items-center">
                    <ul className="navbar-nav flex-row gap-4">
                        {navLinks.map((link) => (
                            <li className="nav-item" key={link.path}>
                                <Link
                                    to={link.path}
                                    className={`nav-link ${location.pathname === link.path ? 'active' : ''} text-copperplate`}
                                    style={{
                                        fontSize: '1.25rem',
                                        fontFamily: 'Copperplate, Copperplate Gothic Light, fantasy',
                                        textDecoration: location.pathname === link.path ? 'underline' : 'none',
                                        color: location.pathname === link.path ? '#000000' : '#ffffff',
                                    }}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </nav>

            {/* Mobile Menu - Slides in from right */}
            {isMenuOpen && (
                <div
                    className="d-md-none position-fixed top-0 end-0 h-100 bg-primary text-white p-4 shadow-lg"
                    style={{
                        width: '75%',
                        zIndex: 1050,
                        overflowY: 'auto',
                        transition: 'transform 0.3s ease-in-out',
                        transform: isMenuOpen ? 'translateX(0)' : 'translateX(100%)'
                    }}
                >
                    <div className="d-flex flex-column h-100">
                        {/* Close Button at Top Right */}
                        <div className="d-flex justify-content-end mb-4">
                            <button
                                className="btn btn-link text-white p-0"
                                onClick={toggleMenu}
                                aria-label="Close menu"
                            >
                                <FaTimes size={24} />
                            </button>
                        </div>

                        {/* Mobile Contact Info */}
                        <div className="mb-4">
                            <p className="mb-2">CALL US NOW: +94 77 7922 009</p>
                            <div className="d-flex align-items-center gap-3 mt-3">
                                <a href="tel:+94777922009" aria-label="Phone" className="text-white">
                                    <FaPhone size={20} />
                                </a>
                                <a href="https://maps.app.goo.gl/p8mQ1ZqWZPSRDMMr5" target="_blank" rel="noopener noreferrer" aria-label="Location" className="text-white">
                                    <FaMapMarkerAlt size={20} />
                                </a>
                                <a href="mailto:marcsrihomes@gmail.com" aria-label="Email" className="text-white">
                                    <FaEnvelope size={20} />
                                </a>
                                <a href="https://web.facebook.com/MarcsriHomes/?_rdc=1&_rdr" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-white">
                                    <FaFacebook size={20} />
                                </a>
                                <a href="https://wa.me/+94771581869" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="text-white">
                                    <FaWhatsapp size={20} />
                                </a>
                            </div>
                        </div>

                        {/* Mobile Navigation Links */}
                        <ul className="nav flex-column flex-grow-1 mb-3">
                            {navLinks.map((link) => (
                                <li className="nav-item mb-3" key={link.path}>
                                    <Link
                                        to={link.path}
                                        className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                                        style={{
                                            fontSize: '1.1rem',
                                            fontFamily: 'Copperplate, Copperplate Gothic Light, fantasy',
                                            textDecoration: location.pathname === link.path ? 'underline' : 'none',
                                            color: location.pathname === link.path ? '#000000' : '#ffffff',
                                        }}
                                        onClick={toggleMenu}
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>

                        {/* Donate Now Button at Bottom */}
                        <div className="mt-auto pt-3">
                            <Link
                                to="/contact-us"
                                className="btn btn-light w-100"
                                onClick={toggleMenu}
                            >
                                Donate Now
                            </Link>
                        </div>
                    </div>
                </div>
            )}

            {/* Overlay when menu is open */}
            {isMenuOpen && (
                <div
                    className="position-fixed top-0 start-0 h-100 w-100 bg-dark opacity-50"
                    style={{ zIndex: 1040 }}
                    onClick={toggleMenu}
                />
            )}
        </div>
    );
};

export default Navbar;